<template>
  <div>
    <slot name="mobile-navbar">
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="e296a164-57eb-5ae3-cb7a-7c29806a8e27"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
        v-if="
          userInfo.userRole === 'CUSTOMER' &&
            !customerToProfessionalId &&
            Object.keys(userInfo).length !== 0
        "
      >
        <div class="navbar1_container">
          <div class="navbar1_logo-link w-nav-brand" @click="home">
            <img
              src="../../assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
            />
          </div>
          <div
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
            @click="showNav"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
              <div
                class="menu-icon1_line-middle"
                style="width: 24px; height: 2px;"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
            </div>
          </div>
        </div>
        <!--        w-nav-overlay-0 id name-->
        <div
          class="w-nav-overlay slide-in"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          v-if="cross"
        >
          <nav
            role="navigation"
            id="nav"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);"
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="e296a164-57eb-5ae3-cb7a-7c29806a8e2d"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="../../assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <img
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="image-profile-pic"
                      :src="customerInfo.customerDisplayPicture"
                    />
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfile" class="link-18">View profile</a>
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/client-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/customer-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/customer-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>
                  <router-link
                    to="/customer-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/customer-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/customer-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/customer-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/become-a-professional"
                    class="link-block-4 professional w-inline-block"
                  >
                    <div class="text-block-27">Become a professional</div>
                  </router-link>
                  <router-link
                    to="/discover-professionals"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <!--                  <router-link-->
                  <!--                    to="/customer-notifications"-->
                  <!--                    class="link-block-4 conection w-inline-block"-->
                  <!--                  >-->
                  <!--                    <div class="text-block-27">Notifications</div>-->
                  <!--                  </router-link>-->
                  <router-link
                    to="/customer-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <div class="link-block-4 log-out w-inline-block">
                    <div class="text-block-27" @click="logOut">Log out</div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
      <div
        v-else-if="
          (userInfo.userRole !== 'CUSTOMER' || customerToProfessionalId) &&
            Object.keys(userInfo).length !== 0
        "
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
      >
        <div class="navbar1_container">
          <router-link
            to="/professional-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></router-link>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <div v-if="customerInfo.customerDisplayPicture !== null">
                      <img :src="customerInfo.customerDisplayPicture" />
                    </div>
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfProfile" class="link-18"
                        >View profile</a
                      >
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>
                  <router-link
                    to="/professional-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/professional-availability"
                    class="link-block-4 availability w-inline-block"
                  >
                    <div class="text-block-27">Availability</div>
                  </router-link>
                  <router-link
                    to="/professional-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/professional-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/discover-professionals"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <a
                    @click="logOut"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
      <div
        v-else
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-w-id="519dbec9-6ecd-29c5-c2ca-e2acf9a27145"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="timeslot-navbar w-nav small"
      >
        <div class="navbar-wrapper">
          <a href="https://www.timeslate.com" class="timeslot-logo w-nav-brand">
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
            />
          </a>
          <div
            @click="showNav"
            v-if="bar"
            class="meu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
              <div
                class="menu-icon1_line-middle"
                style="width: 24px; height: 2px;"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
            </div>
          </div>
          <div
            class="meu-button w-nav-button w--open"
            @click="closeNav"
            v-if="cross"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="true"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                style="transform: translate3d(0px, 8px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-45deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
              <div
                class="menu-icon1_line-middle"
                style="width: 0px; height: 2px;"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                style="transform: translate3d(0px, -8px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              ></div>
            </div>
          </div>

          <!--            <div class="meu-button w-nav-button" style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false">-->
          <!--              <div class="menu-icon1">-->
          <!--                <div class="menu-icon1_line-top" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
          <!--                <div class="menu-icon1_line-middle" style="width: 24px; height: 2px;">-->
          <!--                  <div class="menu-icon_line-middle-inner"></div>-->
          <!--                </div>-->
          <!--                <div class="menu-icon1_line-bottom" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          class="w-nav-overlay "
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; background-color: white;"
          v-if="cross"
        >
          <nav
            role="navigation"
            class="navbar-menu w-nav-menu"
            style="transform: translateY(0px) translateX(0px); transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <a
              href="https://www.timeslate.com/discover"
              class="navbar1_link w-nav-link w--nav-link-open"
              >Discover</a
            >
            <a
              href="https://www.timeslate.com/become-a-pro"
              class="navbar1_link w-nav-link w--nav-link-open"
              >Become a Professional</a
            >
            <div class="navbar1_menu-buttons">
              <div class="navbar1_button-wrapper">
                <router-link to="/login" class="login-button w-button"
                  >Login</router-link
                >
              </div>
              <div class="navbar1_button-wrapper">
                <router-link to="/get-started" class="sign-up-button w-button"
                  >Get Started</router-link
                >
              </div>
            </div>
          </nav>
        </div>
      </div>
    </slot>
    <div class="app wf-section">
      <slot name="app-navbar">
        <AppNavBar
          v-if="
            userInfo.userRole === 'CUSTOMER' &&
              !customerToProfessionalId &&
              Object.keys(userInfo).length !== 0
          "
        />
        <ProfessionalAppNavBar
          v-else-if="
            (userInfo.userRole !== 'CUSTOMER' || customerToProfessionalId) &&
              Object.keys(userInfo).length !== 0
          "
        />
        <LandingPageNavBar v-else />
      </slot>
      <slot />
    </div>
    `
  </div>
</template>

<script>
import AppNavBar from "../navbar/AppNavBar";
import { mapState } from "vuex";
import ProfessionalAppNavBar from "../navbar/ProfessionalAppNavBar";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";
import StoreUtils from "../../utils/BaseUtils/StoreUtils";
import LandingPageNavBar from "../../views/timeslot/LandingPageNavBar";

export default {
  name: "WebsiteLayout",
  components: { AppNavBar, ProfessionalAppNavBar, LandingPageNavBar },
  data() {
    return {
      bar: true,
      cross: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      professionals: state => state.professional.professionals,
      professionalId: state => state.professional.professionalId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    })
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/clients/${this.userInfo.customerId}`);
    },
    goToProfProfile() {
      let professionalId;
      if (this.userInfo.professional.professionalId) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logOut() {
      StoreUtils.dispatch("auth/logout");
    },
    home() {
      if (
        this.userInfo.userRole.toLowerCase() === "customer" &&
        this.professionals.filter(
          item => item.professionalId === this.customerToProfessionalId
        ).length === 0
      ) {
        RouterUtils.changeRouteUrlTo("/client-dashboard");
      } else {
        RouterUtils.changeRouteUrlTo("/professional-dashboard");
      }
    }
  }
};
</script>

<style scoped>
.slide-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-enter-to {
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave {
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.slide-in {
  animation: 1s ease-out 0s 1 slideInLeft;
}

@media only screen and (min-width: 992px) {
  .timeslot-navbar.w-nav.small {
    display: none;
  }
}
</style>
